import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import DropdownSingleSelect from '../dropdown-single-select/dropdown-single-select';
import Input, { InputTypes } from '../input/input';
import './input-with-dropdown.scss';

const InputWithDropdown = ({
  type,
  className,
  placeholder,
  value,
  label,
  isDisabled,
  isReadOnly,
  hintText,
  isInvalid,
  leftAddOn,
  prefix,
  suffix,
  onChange,
  onBlur,
  searchAction,
  inputProps,
  autoFocus,
  onClick,
  onKeyUp,
  dropdownItems,
  onDropdownItemSelect,
  onInput,
  allowDecimal,
}) => {
  const handleItemSelect = (id) => {
    onDropdownItemSelect(id);
  };

  const renderDropDown = () => (
    <DropdownSingleSelect
      items={dropdownItems}
      onSelect={handleItemSelect}
    />
  );

  return (
    <Input
      rightAddOn={renderDropDown()}
      type={type}
      className={clsx(['input-w-dd', className])}
      placeholder={placeholder}
      value={value}
      label={label}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      hintText={hintText}
      isInvalid={isInvalid}
      leftAddOn={leftAddOn}
      prefix={prefix}
      suffix={suffix}
      onChange={onChange}
      onBlur={onBlur}
      searchAction={searchAction}
      onClick={onClick}
      onKeyUp={onKeyUp}
      inputProps={inputProps}
      autoFocus={autoFocus}
      allowDecimal={allowDecimal}
      onInput={onInput}
    />
  );
};

InputWithDropdown.propTypes = {
  type: PropTypes.oneOf(Object.values(InputTypes)),
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isInvalid: PropTypes.bool,
  hintText: PropTypes.string,
  leftAddOn: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyUp: PropTypes.func,
  searchAction: PropTypes.func,
  inputProps: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    ariaLabel: PropTypes.string,
  }),
  autoFocus: PropTypes.bool,
  onClick: PropTypes.func,
  dropdownItems: PropTypes.oneOf([null, []]),
  onDropdownItemSelect: PropTypes.func,
  onInput: PropTypes.func,
  allowDecimal: PropTypes.bool,
};

InputWithDropdown.defaultProps = {
  type: InputTypes.TEXT,
  className: '',
  placeholder: null,
  value: '',
  label: '',
  isDisabled: false,
  isReadOnly: false,
  isInvalid: false,
  hintText: '',
  leftAddOn: null,
  prefix: null,
  suffix: null,
  onChange: () => {},
  onBlur: () => {},
  onKeyUp: () => {},
  searchAction: null,
  inputProps: {},
  autoFocus: false,
  onClick: () => {},
  dropdownItems: [],
  onDropdownItemSelect: () => {},
  onInput: () => {},
  allowDecimal: true,
};

export default InputWithDropdown;
